import React from 'react'
import PropTypes from 'prop-types'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import TextField from '@material-ui/core/TextField'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'

import { isMobile } from '../../../../utils'
import { provinces } from '../../../../config'
import { styles } from '../../styles'

export const HeroForm = ({
  me,
  handleSubmit,
  touched,
  errors,
  handleChange,
  setFieldValue,
  values,
  handleBlur,
  handleUpload,
  saveHeroImage
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <Card elevation={isMobile ? 0 : 1} style={styles.card}>
        <div style={styles.avatarWrapper}>
          <input
            style={styles.input}
            accept="image/*"
            id="avatar-button-file"
            onChange={(e) => handleUpload({ e, heroId: me.id, saveHeroImage })}
            type="file"
          />
          <label htmlFor="avatar-button-file">
            <Avatar style={styles.avatar} src={me.imageUrl}>
              <Typography variant="h3" color="inherit">
                {me.name && me.name.substring(0, 1)}
              </Typography>
            </Avatar>
          </label>
        </div>
        <CardContent style={{ textAlign: 'center' }}>
          <FormControl
            margin="normal"
            fullWidth
            error={touched.tel && Boolean(errors.tel)}>
            <TextField
              id="inputTel"
              type="text"
              name="tel"
              label="เบอร์โทรศัพท์ (Telephone)"
              value={values.tel}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.tel && Boolean(errors.tel)}
            />
            {touched.tel && errors.tel && (
              <FormHelperText>{errors.tel}</FormHelperText>
            )}
          </FormControl>
          <FormControl
            margin="normal"
            fullWidth
            error={touched.email && Boolean(errors.email)}>
            <TextField
              id="inputEmail"
              type="text"
              name="email"
              label="อีเมล (Email)"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.email}
              error={touched.email && Boolean(errors.email)}
            />
            {touched.email && errors.email && (
              <FormHelperText>{errors.email}</FormHelperText>
            )}
          </FormControl>
          <FormControl
            margin="normal"
            fullWidth
            error={touched.name && Boolean(errors.name)}>
            <TextField
              id="inputName"
              type="text"
              name="name"
              label="ชื่อฮีโร่/ชื่อร้าน (Hero's name)"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.name && Boolean(errors.name)}
            />
            {touched.name && errors.name && (
              <FormHelperText>{errors.name}</FormHelperText>
            )}
          </FormControl>

          <FormControl
            margin="normal"
            fullWidth
            error={touched.firstname && Boolean(errors.firstname)}>
            <TextField
              id="inputFirstname"
              type="text"
              name="firstname"
              label="ชื่อจริง (Firstname)"
              value={values.firstname}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.firstname && Boolean(errors.firstname)}
            />
            {touched.firstname && errors.firstname && (
              <FormHelperText>{errors.firstname}</FormHelperText>
            )}
          </FormControl>

          <FormControl
            margin="normal"
            fullWidth
            error={touched.lastname && Boolean(errors.lastname)}>
            <TextField
              id="inputLastname"
              type="text"
              name="lastname"
              label="นามสกุลจริง (Lastname)"
              value={values.lastname}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.lastname && Boolean(errors.lastname)}
            />
            {touched.lastname && errors.lastname && (
              <FormHelperText>{errors.lastname}</FormHelperText>
            )}
          </FormControl>

          <FormControl
            margin="normal"
            fullWidth
            error={touched.address && Boolean(errors.address)}>
            <TextField
              id="inputAddress"
              type="text"
              name="address"
              label="ที่อยู่ (Address)"
              value={values.address}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.address && Boolean(errors.address)}
            />
            {touched.address && errors.address && (
              <FormHelperText>{errors.address}</FormHelperText>
            )}
          </FormControl>

          <FormControl
            margin="normal"
            fullWidth
            error={touched.subDistrict && Boolean(errors.subDistrict)}>
            <TextField
              id="inputSubDistrict"
              type="text"
              name="subDistrict"
              label="ตำบล (Sub-district)"
              value={values.subDistrict}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.subDistrict && Boolean(errors.subDistrict)}
            />
            {touched.subDistrict && errors.subDistrict && (
              <FormHelperText>{errors.subDistrict}</FormHelperText>
            )}
          </FormControl>

          <FormControl
            margin="normal"
            fullWidth
            error={touched.district && Boolean(errors.district)}>
            <TextField
              id="inputDistrict"
              type="text"
              name="district"
              label="อำเภอ (District)"
              value={values.district}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.district && Boolean(errors.district)}
            />
            {touched.district && errors.district && (
              <FormHelperText>{errors.district}</FormHelperText>
            )}
          </FormControl>

          <FormControl margin="normal" fullWidth>
            <InputLabel>จังหวัด (Province)</InputLabel>
            <Select
              value={values.province}
              onChange={(e) => setFieldValue('province', e.target.value)}
              style={{ textAlign: 'left' }}>
              {provinces.map((option, index) => (
                <MenuItem
                  key={`province-${index.toString()}`}
                  value={option.name_th}>
                  {option.name_th}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl
            margin="normal"
            fullWidth
            error={touched.zipcode && Boolean(errors.zipcode)}>
            <TextField
              id="inputZipcode"
              type="text"
              name="zipcode"
              label="รหัสไปรษณีย์ (Zipcode)"
              value={values.zipcode}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.zipcode && Boolean(errors.zipcode)}
            />
            {touched.zipcode && errors.zipcode && (
              <FormHelperText>{errors.zipcode}</FormHelperText>
            )}
          </FormControl>

          <FormControl
            margin="normal"
            fullWidth
            error={touched.lineId && Boolean(errors.lineId)}>
            <TextField
              id="inputLineId"
              type="text"
              name="lineId"
              label="ไอดี ไลน์ (Line ID)"
              value={values.lineId}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.lineId && Boolean(errors.lineId)}
            />
            {touched.lineId && errors.lineId && (
              <FormHelperText>{errors.lineId}</FormHelperText>
            )}
          </FormControl>

          {values.heroType === 'SCOOTER' && (
            <FormControl
              margin="normal"
              fullWidth
              error={touched.plateLicense && Boolean(errors.plateLicense)}>
              <TextField
                id="inputPlateLicense"
                type="text"
                name="plateLicense"
                label="ทะเบียนรถ (License Plate)"
                value={values.plateLicense}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.plateLicense && Boolean(errors.plateLicense)}
              />
              {touched.plateLicense && errors.plateLicense && (
                <FormHelperText>{errors.plateLicense}</FormHelperText>
              )}
            </FormControl>
          )}

          {(values.heroType === 'DROP_POINT' ||
            values.heroType === 'POSTAL') && (
            <FormControl
              margin="normal"
              fullWidth
              error={touched.purpose && Boolean(errors.purpose)}>
              <TextField
                id="inputPurpose"
                type="text"
                name="purpose"
                label="การรับขยะไปแล้วทำอย่างไรต่อ (Purpose of Recieving)"
                multiline
                rows="3"
                value={values.purpose}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.purpose && Boolean(errors.purpose)}
              />
              {touched.purpose && errors.purpose && (
                <FormHelperText>{errors.purpose}</FormHelperText>
              )}
            </FormControl>
          )}

          {values.heroType === 'POSTAL' && (
            <FormControl
              margin="normal"
              fullWidth
              error={touched.postalAddress && Boolean(errors.postalAddress)}>
              <TextField
                id="inputPostalAddress"
                type="text"
                name="postalAddress"
                label="ที่อยู่ไปรษณีย์ในการรับขยะ (Portal Address)"
                multiline
                rows="3"
                value={values.postalAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.postalAddress && Boolean(errors.postalAddress)}
              />
              {touched.postalAddress && errors.postalAddress && (
                <FormHelperText>{errors.postalAddress}</FormHelperText>
              )}
            </FormControl>
          )}
        </CardContent>
      </Card>
    </form>
  )
}

HeroForm.propTypes = {
  me: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  handleUpload: PropTypes.func.isRequired,
  saveHeroImage: PropTypes.func.isRequired
}

export default HeroForm



// WEBPACK FOOTER //
// ./src/pages/Profile/components/HeroForm/index.js